import { createSelector } from "reselect";
import { createMatchSelector } from "connected-react-router";
import queryString from "query-string";

export const getEditorModel = state => ({
  surfaceId: state.editor.selectedSurfaceId,
  patternId: state.editor.selectedPatternId,
  patternConfig: state.editor.patternConfigs[
    state.editor.selectedPatternId
  ] || { index: 0, spacingIndex: 0 }
});

export const getEditorModelId = state => state.editor.modelId;

export const getModelById = (state, id) => state.models.byIds[id];

export const getUser = state => state.user;

export const getUserHasVisited = state => state.user.hasVisited;

export const getUserLoaded = state => state.user.loaded;

export const getAuthLoggedIn = state => state.auth.loggedIn;

export const getUserId = state => state.auth.uid;

export const getAuthUid = state => state.auth.uid;

export const getAuthLoaded = state => state.auth.loaded;

export const getModels = state => state.models;

export const getModelsLoaded = state => state.models.loaded;

export const getFolders = state => state.folders;

export const getUISidebarsOpen = state =>
  state.ui.leftSidebarOpen || state.ui.rightSidebarOpen;

export const getUIEditor = state => state.ui.editor;

export const getRouterQueryFrom = state => {
  const { from } = queryString.parse(state.router.location.search);

  return from;
};

export const getLocaleLng = state => state.locale.lng;

export const getRouterLocale = state => {
  const defaultLocale = "fr";
  const matchSelector = createMatchSelector({ path: "/:locale(en|es)?" });
  const match = matchSelector(state);

  return match.params.locale || defaultLocale;
};

export const getBodyOverflow = createSelector(
  [getUISidebarsOpen, getUIEditor],
  (sidebarsOpen, editor) => sidebarsOpen || editor
);



// WEBPACK FOOTER //
// ./src/selectors.js